/** The dialog field label now lives in `src/shared/ui`; the deletion dialog uses it too. */
export { FieldLabel as LicenceFieldLabel } from '@/shared/ui/field-label';
